import React, { useState, useRef, useEffect } from 'react';
import '../styles/Header.css';
import menuIcon from '../images/menu.png';

const Header = ({ scrolled }) => {
  const redirectHome = () => {
    window.location.href = '/home';
  };

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [menuLevel, setMenuLevel] = useState('main');
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isCCLHovered, setIsCCLHovered] = useState(false);
  const [isDraftHovered, setIsDraftHovered] = useState(false);

  const mobileMenuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const mobileMenuNode = mobileMenuRef.current;
      if (mobileMenuNode && isMobileMenuOpen && event.target instanceof Node &&
        !mobileMenuNode.contains(event.target) &&
        event.target !== document.querySelector('.d-lg-none.d-flex.align-items-center img')) {
        setIsMobileMenuOpen(false);
        setMenuLevel('main');
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isMobileMenuOpen]);

  const goBack = () => {
    if (menuLevel === 'ccl' || menuLevel === 'draft') {
      setMenuLevel('services');
    } else if (menuLevel === 'services') {
      setMenuLevel('main');
    }
  };

  const handleMobileMenuToggle = () => {
    setIsMobileMenuOpen(prev => !prev);
    if (isMobileMenuOpen) {
      setMenuLevel('main');
    }
  };

  const handleNavigate = (href) => {
    window.location.href = href;
    setIsMobileMenuOpen(false);
  };

  const handleOpenSubmenu = (e, nextLevel) => {
    e.stopPropagation();
    setMenuLevel(nextLevel);
    setIsServicesOpen(true);
  };

  const handleServicesMouseEnter = () => {
    setIsServicesOpen(true);
  };

  const handleServicesMouseLeave = () => {
    setIsServicesOpen(false);
    setMenuLevel('main');
  };

  return (
    <div className={`header d-flex w-100 align-items-center justify-content-between px-4 ${scrolled ? 'header-scrolled' : ''}`}>
      <div className='d-flex align-items-center gap-3 justify-content-start'>
        <div className='templogo' onClick={redirectHome}></div>
        <div className='kwaHeader fw-bold' onClick={redirectHome}>KANWALL WALIA ASSOCIATES</div>
      </div>

      {/* Desktop Menu */}
      <div className='d-lg-flex d-none justify-content-center headerTabsDiv position-relative'>
        <a href='/about' className='p-3'>About Us</a>

        <div
          className='position-relative p-3 cursor-pointer'
          onMouseEnter={handleServicesMouseEnter}
          onMouseLeave={handleServicesMouseLeave}
        >
          Services
          {isServicesOpen && (
            <div className='ServicesBox d-flex position-absolute flex-column'>

              {/* Criminal & Civil litigation */}
              <div
                className='ServicesOptions cursor-pointer position-relative'
                onMouseEnter={() => setIsCCLHovered(true)}
                onMouseLeave={() => setIsCCLHovered(false)}
              >
                Criminal & Civil litigation &gt;
                {isCCLHovered && (
                  <div className='submenuBox d-flex flex-column CCLBox position-absolute'>
                    <a href='/cclfamily' className='ServicesOptions'>Family</a>
                    <a href='/ccllop' className='ServicesOptions'>Laws of Property</a>
                  </div>
                )}
              </div>

              <a href='/cheq' className='ServicesOptions'>Cheque Bouncing (S-138 NI Act)</a>
              <a href='/will' className='ServicesOptions'>Family matters, Will & Succession</a>
              <a href='/landrevenue' className='ServicesOptions'>Revenue and Land Disputes</a>
              <a href='/commercial' className='ServicesOptions'>Commercial and Contractual Laws</a>
              <a href='/consumer' className='ServicesOptions'>Consumer Protection Laws</a>
              <a href='/dispute' className='ServicesOptions'>Dispute Resolution</a>
              <a href='/intellectual' className='ServicesOptions'>IPR Laws</a>
              <a href='/corporate' className='ServicesOptions'>Corporate & Banking</a>

              {/* Drafting & Opinions */}
              <div
                className='ServicesOptions cursor-pointer position-relative'
                onMouseEnter={() => setIsDraftHovered(true)}
                onMouseLeave={() => setIsDraftHovered(false)}
              >
                Drafting & Opinions &gt;
                {isDraftHovered && (
                  <div className='submenuBox d-flex flex-column DraftBox position-absolute'>
                    <a href='/draftcc' className='ServicesOptions'>Commercial Contracts</a>
                    <a href='/drafttender' className='ServicesOptions'>Tenders</a>
                  </div>
                )}
              </div>

            </div>
          )}
        </div>

        <a href='/career' className='p-3'>Careers</a>
        <a href='/contact' className='p-3'>Contact Us</a>
      </div>

      {/* Mobile Menu */}
      <div className='d-lg-none d-flex align-items-center' onClick={handleMobileMenuToggle}>
        <img src={menuIcon} alt='Menu' style={{ width: '30px', cursor: 'pointer' }} />
      </div>

      {isMobileMenuOpen && (
        <div className='mobileMenu position-absolute' ref={mobileMenuRef}>
          <div className='d-flex flex-column position-relative justify-content-center align-items-center'>

            {menuLevel !== 'main' && (
              <div className='backButton mb-3 w-100' onClick={goBack}>← Back</div>
            )}

            {menuLevel === 'main' && (
              <>
                <div onClick={() => handleNavigate('/about')}>About Us</div>
                <hr />
                <div onClick={(e) => handleOpenSubmenu(e, 'services')}>Services</div>
                <hr />
                <div onClick={() => handleNavigate('/career')}>Careers</div>
                <hr />
                <div onClick={() => handleNavigate('/contact')}>Contact Us</div>
              </>
            )}

            {menuLevel === 'services' && (
              <>
                <div onClick={(e) => handleOpenSubmenu(e, 'ccl')}>Criminal & Civil litigation &gt;</div>
                <hr />
                <div onClick={() => handleNavigate('/cheq')}>Cheque Bouncing</div>
                <hr />
                <div onClick={() => handleNavigate('/will')}>Family, Will & Succession</div>
                <hr />
                <div onClick={() => handleNavigate('/landrevenue')}>Revenue and Land</div>
                <hr />
                <div onClick={() => handleNavigate('/commercial')}>Commercial & Contractual</div>
                <hr />
                <div onClick={() => handleNavigate('/consumer')}>Consumer Protection</div>
                <hr />
                <div onClick={() => handleNavigate('/dispute')}>Dispute Resolution</div>
                <hr />
                <div onClick={() => handleNavigate('/intellectual')}>IPR</div>
                <hr />
                <div onClick={() => handleNavigate('/corporate')}>Corporate & Banking</div>
                <hr />
                <div onClick={(e) => handleOpenSubmenu(e, 'draft')}>Drafting & Opinions &gt;</div>
              </>
            )}

            {menuLevel === 'ccl' && (
              <>
                <div onClick={() => handleNavigate('/cclfamily')}>Family</div>
                <hr />
                <div onClick={() => handleNavigate('/ccllop')}>Laws of Property</div>
              </>
            )}

            {menuLevel === 'draft' && (
              <>
                <div onClick={() => handleNavigate('/draftcc')}>Commercial Contracts</div>
                <hr />
                <div onClick={() => handleNavigate('/drafttender')}>Tenders</div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Header;
